/* lua.js generated code 0.3.0 */

//var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
//var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
RevisitPanel = xClass("RevisitPanel", BasePanel, function (recTime, rewards, dcSession) {
    if (recTime == 0 && rewards && rewards[1]){
        return cc.CSLoader.createNode("cocos/tt_tt_sidehint_reward.csb")
    }else{
        return cc.CSLoader.createNode("cocos/tt_tt_sidehint.csb")
    }
})

RevisitPanel.show = function (recTime, rewards, dcSession, fetchCb) {
    var panel = RevisitPanel.create(recTime, rewards, dcSession, fetchCb)
    panel.popup(true)
}

RevisitPanel.prototype.ctor = function (recTime, rewards, dcSession, fetchCb) {
    var self = this
    self.dcSession = dcSession
    self.fetchCb = fetchCb
    self.canFetchReward = false
    if (recTime == 0 && rewards && rewards[1]){
        self.dcType = "limit_reward"
        self.canFetchReward = true
    }else{
        self.dcType = "reminder"
    }
    self.init(recTime, rewards)
    DCAssist.dc4DouyinSidebar("page_show", self.dcSession, self.dcType)
}

RevisitPanel.prototype.init = function (recTime, rewards) {
    var self = this
    BasePanel.prototype.init.call(self)

    console.log("[tt] RevisitPanel rewards", rewards)

    //  关闭按钮
    var closeSp = self.getChildByName("com_close")
    var closeBtn = UIButton.create(closeSp) 
    closeBtn.on(UIButtonEvent.Click, function () {
        DCAssist.dc4DouyinSidebar("page_click", self.dcSession, self.dcType, "close")
        self.onClose()
    })
    self.closeBtn = closeBtn

    //title
    var titleSp = self.getChildByName("com_title")
    var titleTxt = titleSp.getChildByName("txt_title")
    titleTxt.setPositionY(titleTxt.getPositionY() - 5)

    //  提示按钮
    var gotSp = self.getChildByName("btnGot")
    var txt = gotSp.getChildByName("txt")
    txt.setPositionY(txt.getPositionY() - 25)
    var gotBtn = UIButton.create(gotSp) 
    gotBtn.on(UIButtonEvent.Click, function () {
        if (!self.canFetchReward){
            DCAssist.dc4DouyinSidebar("page_click", self.dcSession, self.dcType, "known")
            self.onClose()
            return
        }
        DCAssist.dc4DouyinSidebar("page_click", self.dcSession, self.dcType, "to_finish")
        window.mini.navigateToScene({
            scene:"sidebar",
            success(){
                console.log("[tt] revisit navigateToScene sidebar success")
                self.isBusy = false
                self.onClose()
                if (self.fetchCb){
                    self.fetchCb()
                }
            },
            fail(res){
                self.isBusy = false
                console.log("[tt] revisit failed %s", res.errMsg)
                self.onClose()
            }
        })
    })
    self.gotBtn = closeBtn

    if (recTime == 0 && rewards){
        for (let i = 1; i < Math.min(rewards.length, 3); i++) {
            const r = rewards[i];
            let [icon, onTouchFunc] = UIItemBuilder.createProp(r.itemId, r.num)
            let iconBg = self.getChildByName("com_iconbg0"+i).getChildByName("icon")
            iconBg.addChild(icon)
        }
    }
}

module.exports = RevisitPanel